import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Element } from '../../../../common/html/element'
import { Radio } from '../../../../common/html/radio'
import { SelectCustom } from '../../../../common/selectCustom'
import TextEllipsis from '../../../../common/textEllipsis'
import { SORT_DIRECTION } from '../../../../utils/common'
import { selectScreeningIndicatorById } from '../../common/store/slice'
import { changeSortBy, selectSortBy, selectViews } from '../store/slice'

export const ViewSort = () => {
  const dispatch = useDispatch()

  const screeningIndicatorById = useSelector(selectScreeningIndicatorById())
  const viewsData = useSelector(selectViews)
  const sortBy = useSelector(selectSortBy)

  const selectData = viewsData
    .filter((item, index) => {
      return (
        viewsData.findIndex(
          (view) =>
            screeningIndicatorById[view.screeningIndicatorId]
              ?.screeningIndicatorName ===
              screeningIndicatorById[item.screeningIndicatorId]
                ?.screeningIndicatorName && view.year === item.year,
        ) === index
      )
    })
    .map((item) => ({
      ...item,
      label:
        screeningIndicatorById[item.screeningIndicatorId]
          .screeningIndicatorName +
        ' - ' +
        item.year,
    }))

  const onChangeSortBy = (item) => {
    if (!item.screeningIndicatorId) {
      dispatch(
        changeSortBy({ ...sortBy, screeningIndicatorId: null, year: null }),
      )
    } else {
      dispatch(
        changeSortBy({
          ...sortBy,
          screeningIndicatorId: item.screeningIndicatorId,
          year: item.year,
        }),
      )
    }
  }

  const onChangeSortDirection = (value) => {
    dispatch(
      changeSortBy({
        ...sortBy,
        sortDirection: value,
      }),
    )
  }

  useEffect(() => {
    if (
      sortBy.screeningIndicatorId &&
      sortBy.year &&
      !viewsData.find(
        (view) =>
          view.screeningIndicatorId === sortBy.screeningIndicatorId &&
          view.year === sortBy.year,
      )
    ) {
      dispatch(
        changeSortBy({
          ...sortBy,
          screeningIndicatorId: null,
          year: null,
        }),
      )
    }
  }, [viewsData, sortBy])

  return (
    <Element className="dFlex gap1 alignItemsCenter flexWrap">
      <Element style={{ opacity: !selectData.length ? 0.4 : 1 }}>
        <SelectCustom
          activeItem={sortBy}
          renderActiveItem={() => {
            if (sortBy.screeningIndicatorId) {
              return (
                <TextEllipsis
                  text={`${
                    screeningIndicatorById[sortBy.screeningIndicatorId]
                      .screeningIndicatorName
                  } - ${sortBy.year}`}
                  appendStyle={{ paddingRight: 12 }}
                />
              )
            } else {
              return <>&nbsp;</>
            }
          }}
          data={[{ label: <>&nbsp;</>, isI18n: false }, ...selectData]}
          chooseItem={onChangeSortBy}
          style={{
            fontSize: 12,
            backgroundColor: '#FFFFFF',
            padding: '5px 12px',
            width: 187,
          }}
          className="dFlex justifyContentBetween"
          disabled={!selectData.length}
        />
      </Element>
      <Element
        className="dFlex gap1 alignItemsCenter"
        style={{
          opacity: !selectData.length || !sortBy.screeningIndicatorId ? 0.4 : 1,
        }}
      >
        {Object.keys(SORT_DIRECTION).map((key) => (
          <Radio
            key={key}
            value={SORT_DIRECTION[key]}
            title={`screening.${key}`}
            activeValue={sortBy.sortDirection}
            onChange={onChangeSortDirection}
            disabled={!selectData.length || !sortBy.screeningIndicatorId}
          />
        ))}
      </Element>
    </Element>
  )
}
